module.exports = __webpack_public_path__ + "img/mako-satin_thumbnail.dc2c5be8.jpg";